import { Client as ClientEngine } from 'styletron-engine-atomic';
import { STYLETRON_CLASS_PREFIX, STYLETRON_SHEET_CLASS_NAME } from './common';

let globalClientEngine: ClientEngine;

/** In the browser, finds server-rendered Styletron stylesheets in the DOM and creates an engine
 * from them. Subsequent calls will receive the same shared instance of the engine, as multiple
 * Styletron instances on a page will interfere with each other.
 *
 * On the server, returns undefined.
 *
 * We permit the global document to be used here because we want to keep this decoupled from
 * our dependency injection system.
 */
/* eslint-disable no-restricted-globals */
export const rehydrateClientEngine = (): ClientEngine | undefined => {
  if (globalClientEngine === undefined && typeof document !== 'undefined') {
    const stylesheets = document.getElementsByClassName(STYLETRON_SHEET_CLASS_NAME);

    const filteredSheets = [...stylesheets].filter(
      (it): it is HTMLStyleElement => it.nodeName.toLowerCase() === 'style',
    );

    globalClientEngine = new ClientEngine({
      hydrate: filteredSheets,
      prefix: STYLETRON_CLASS_PREFIX,
    });
  }

  return globalClientEngine;
};
